import { z } from "zod";

export type UserSearchFilter = {
  searchterm?: string;
  activeonly?: boolean;
  securityrole?: number;
  page?: number;
  size?: number;
  sortAttr?: string;
  sortDir?: "ASC" | "DESC";
};

const baseUserSchema = z.object({
  title: z.string().optional(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  phone: z.string().optional(),
  registrationNumber: z.string().optional(),
  shortCode: z.string().optional(),
  organisationId: z.number(),
  privileges: z.array(z.object({ key: z.string() })),
});

const createUserSchema = baseUserSchema.extend({
  addToDefaultTeam: z.boolean().optional(),
  securityRoles: z.array(z.object({ key: z.string() })),
});

export type CreateUser = z.infer<typeof createUserSchema>;

export const createdUserSchema = baseUserSchema.extend({
  id: z.number(),
  isSuspended: z.boolean(),
  securityRoles: z.array(
    z.object({
      key: z.string(),
      name: z.string(),
    })
  ),
});

export type CreatedUser = z.infer<typeof createdUserSchema>;

export const updateUserSchema = createUserSchema.extend({
  id: z.number(),
  isSuspended: z.boolean().optional(),
});

export type UpdateUser = z.infer<typeof updateUserSchema>;

export const userSearchResponseSchema = z.object({
  page: z.number(),
  count: z.number(),
  total: z.number(),
  pages: z.number(),
  size: z.number(),
  searchterm: z.string().optional(),
  results: z.array(
    z.object({
      id: z.number(),
      firstName: z.string(),
      lastName: z.string(),
      email: z.string(),
      suspended: z.boolean(),
      isAdminUser: z.boolean(),
    })
  ),
  sortdir: z.enum(["ASC", "DESC"]),
  sortattr: z.string(),
});

export type UserSearchResponse = z.infer<typeof userSearchResponseSchema>;
